import { render, staticRenderFns } from "./AppLayoutAbout.vue?vue&type=template&id=7a1a3dea&scoped=true"
import script from "./AppLayoutAbout.vue?vue&type=script&lang=js"
export * from "./AppLayoutAbout.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutAbout.vue?vue&type=style&index=0&id=7a1a3dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1a3dea",
  null
  
)

export default component.exports